import { createContext, type ReactNode, useContext, useMemo } from 'react'

import config from 'src/config'
import {
  LandingPageProductInquirySettings,
  resolveLandingPageProductInquirySettings,
} from 'src/shared/dbTypes/landingPageSettings'

export type ProductInquiryConfig = Required<LandingPageProductInquirySettings>

const ProductInquiryContext = createContext<ProductInquiryConfig>(
  resolveLandingPageProductInquirySettings(config.productInquiry)
)

export const ProductInquiryProvider = ({
  settings,
  children,
}: {
  settings?: LandingPageProductInquirySettings
  children?: ReactNode
}) => {
  const value = useMemo(
    () => resolveLandingPageProductInquirySettings(config.productInquiry, settings),
    [settings]
  )

  return <ProductInquiryContext.Provider value={value}>
    {children}
  </ProductInquiryContext.Provider>
}

export const useProductInquiryConfig = () => useContext(ProductInquiryContext)
